import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const ALLOWED_RATIOS = [1, 4 / 5, 3 / 4]
const RATIO_TOLERANCE = 0.02

const isVideoMedia = (media) => media?.type?.startsWith?.('video/')

const hasUnsupportedRatio = (media) => {
  if (!media?.width || !media?.height || isVideoMedia(media)) return false
  const ratio = media.width / media.height
  return !ALLOWED_RATIOS.some((allowedRatio) => Math.abs(ratio - allowedRatio) <= RATIO_TOLERANCE)
}

export const useCarouselWarnings = ({ cards = [] }) => {
  const { t } = useTranslation()

  return useMemo(() => {
    const cardWarningsById = {}
    let hasVideoWarning = false
    let hasAspectRatioWarning = false

    cards.forEach((card) => {
      const media = card?.media
      if (!media) return

      const cardWarnings = []

      if (isVideoMedia(media)) {
        hasVideoWarning = true
        cardWarnings.push(t('Recommendations.campaign.setup.carouselAd.warnings.card.video'))
      }

      if (hasUnsupportedRatio(media)) {
        hasAspectRatioWarning = true
        cardWarnings.push(t('Recommendations.campaign.setup.carouselAd.warnings.card.aspectRatio'))
      }

      if (cardWarnings.length) {
        cardWarningsById[card.id] = cardWarnings
      }
    })

    const groupWarnings = []
    if (hasVideoWarning) {
      groupWarnings.push(t('Recommendations.campaign.setup.carouselAd.warnings.group.video'))
    }

    if (hasAspectRatioWarning) {
      groupWarnings.push(t('Recommendations.campaign.setup.carouselAd.warnings.group.aspectRatio'))
    }

    return {
      groupWarnings,
      cardWarningsById,
    }
  }, [cards, t])
}
